var siAudio = {};

function initAudio() {
	siAudio['sfx'] = {};
	siAudio['sfx']['click'] = new Howl({
		src: ['media/audio/sounds/mouse_click.mp3'],
		volume: 0.8
	});
	siAudio['sfx'].wrong = new Howl({
		src: ['media/audio/sounds/negative.mp3'],
		volume: 0.5
	});
	siAudio['sfx'].right = new Howl({
		src: ['media/audio/sounds/positive.mp3'],
		volume: 0.5
	});
	siAudio['sfx'].nothing = new Howl({
		src: ['media/audio/sounds/nothing.mp3']
	});

	for (key in slides) {
		siAudio[key] = {};
		if (slides[key]['audio']) {
			var audio = slides[key]['audio'];
			for (track in audio) {
				siAudio[key][track] = new Howl({
					src: audio[track],
					onplay: onplayClosure(track),
					onend: onendClosure(track, key)
				});
			}
		} else {
			slides[key]['audio'] = {};
		}
	}
}

function onplayClosure(track) {
	return function () {
		if (!globalVar.lockClosersDuringFeedbackVO) return;

		if (track === 'onEnter') return;
		var $closers = $('.si-modal-container__js, .si-modal-closer__js');

		lock($closers);
	};
}
function onendClosure(track, key) {
	return function () {
		if (!globalVar.lockClosersDuringFeedbackVO) return;

		if (track === 'onEnter') return;

		var $closers = $('.si-modal-container__js, .si-modal-closer__js');

		unlock($closers);
	};
}
